

import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";
//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";
//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

import Home from "./components/pages/Home";
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import SessionTimeout from "./SessionTimeout";

import ReceiptIcon from '@mui/icons-material/Receipt';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

import StoreIcon from '@mui/icons-material/Store';
import PersonIcon from '@mui/icons-material/Person';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import PaidIcon from '@mui/icons-material/Paid';
import ListIcon from '@mui/icons-material/List';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import NoteIcon from '@mui/icons-material/Note';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ArticleIcon from '@mui/icons-material/Article';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaymentsIcon from '@mui/icons-material/Payments';
import BedIcon from '@mui/icons-material/Bed';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import EventIcon from '@mui/icons-material/Event';


//Customer
import CustomerIndex from "./components/pages/Customer";
import CustomerEdit from "./components/pages/Customer/Edit";
import { CustomerCreate } from "./components/pages/Customer/Create";
import ConfirmCustomer from "./components/pages/Customer/Confirm";
//Room
import RoomIndex from "./components/pages/Rooms/Index";
import RoomCreate from "./components/pages/Rooms/Create";
import RoomsEdit from "./components/pages/Rooms/Edit";
//Bank
import BankIndex from "./components/pages/Bank/Index";
import BankCreate from "./components/pages/Bank/Create";
import BankEdit from "./components/pages/Bank/Edit";
//Account Head
import ExpenseHeadIndex from "./components/pages/ExpenseHead/Index";
import ExpenseHeadCreate from "./components/pages/ExpenseHead/Create";
import ExpenseHeadEdit from "./components/pages/ExpenseHead/Edit";


import RentedCustomerIndex from "./components/pages/RentCollection/RentedCustomer";
import RentListIndex from "./components/pages/RentCollection/Index";
import BillPrint from "./components/pages/RentCollection/Bill";
//Receipt
import ReceiptIndex from "./components/pages/Receipt/Index";
import ReceiptCreate from "./components/pages/Receipt/Create";
import ReceiptEdit from "./components/pages/Receipt/Edit";
//Income
import IncomeIndex from "./components/pages/Income/Index";
import IncomeCreate from "./components/pages/Income/Create";
import IncomeEdit from "./components/pages/Income/Edit";
//Expense
import ExpenseIndex from "./components/pages/Expense/Index";
import ExpenseCreate from "./components/pages/Expense/Create";
import ExpenseEdit from "./components/pages/Expense/Edit";
//Report
import Ledger from "./components/pages/Report/Ledger";
import LedgerIncExp from "./components/pages/Report/LedgerIncExp";
import CashBook from "./components/pages/Report/CashBook";
import Dues from "./components/pages/Report/Dues";
import Received from "./components/pages/Report/Received";
import RentDetails from "./components/pages/Report/RentDetails";
//vacating
import customervacating from "./components/pages/vacate/CustomerVacating";
//advancebooking
import AdvanceBookingIndex from "./components/pages/AdvanceBooking";
//Payment
import PaymentIndex from "./components/pages/Payment/Index";
import PaymentCreate from "./components/pages/Payment/Create";
import PaymentEdit from "./components/pages/Payment/Edit";

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ResponsiveTypography from "./RepsonisveTypography";

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />
        {/* <AppBar position="static" style={{ backgroundColor: '#5c9588', height: '55px' }}> */}
        <AppBar position="static" style={{ backgroundColor: '#17273F' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography variant="h6" className="dual-text" component="div" style={{ marginLeft: '16px', fontWeight: 'bolder', position: 'relative' }}>
                    <span style={{ fontSize: '13px', color: 'white' }}>{companyName}</span>
                  </Typography>

                  {/* <Typography
                    variant="h5"
                    className="dual-text"
                    component="div"
                    style={{
                      marginLeft: '16px',
                      fontWeight: 'bolder',
                      position: 'relative',
                      display: 'inline-block',
                      fontSize: '24px', // default size for system view
                    }}
                  >
                    <ResponsiveTypography />
                  </Typography> */}
                </Link>
              </div>
              <div className="white-icon" style={{ marginTop: '-5px' }}>
                <Logout />
              </div>
            </Typography>
          </Toolbar>
        </AppBar>
        {/* {roleName !== "Counter" && ( */}
        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>

          {/* <h4 className="dual-tone-text" style={{ fontWeight: 'bolder', marginTop: '18px', marginLeft: '10px' }}> {companyName}</h4> */}
          <List>
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <ListItemText primary="HOME" />
            </ListItem>

            {/* {roleName != "Accounts" && ( */}
            <ListItem button onClick={handleMasterClick}>
              <ListItemText primary="MASTER" />
              {masterOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            {/* )} */}


            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/CompanyIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <StoreIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Company" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/RoomIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <MeetingRoomIcon style={{ color: 'darkred', fontWeight: 'bolder' }} />  <ListItemText primary="Rooms" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CustomerIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'darkblue', fontWeight: 'bolder' }} />  <ListItemText primary="Customer" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/BankIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountBalanceIcon style={{ color: 'darkcyan', fontWeight: 'bolder' }} />  <ListItemText primary="Bank" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ExpenseHeadIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <NoteIcon style={{ color: '#E14D2A', fontWeight: 'bolder' }} />  <ListItemText primary="Account Head" style={{ marginLeft: '3px' }} />
                </ListItem>


              </List>
            </Collapse>

            {/* {roleName != "Accounts" && ( */}
            <ListItem button onClick={handleItemClick}>
              <ListItemText primary="TRANSACTION" />
              {itemOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            {/* )} */}


            <Collapse in={itemOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/RentedCustomerIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PaidIcon style={{ color: '#B47B84', fontWeight: 'bolder' }} />  <ListItemText primary="Rent Retrival" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/RentListIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ListIcon style={{ color: '#FFBE98', fontWeight: 'bolder' }} />  <ListItemText primary="Rent List" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ReceiptIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ReceiptIcon style={{ color: '#436850', fontWeight: 'bolder' }} />  <ListItemText primary="Rent Receipt" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PaymentIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PaymentsIcon style={{ color: '#9B3922', fontWeight: 'bolder' }} />  <ListItemText primary="Payment" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/customervacating" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonOutlineIcon style={{ color: '#CBA96C' }} />
                  <ExitToAppIcon style={{ color: 'red', fontWeight: 'bolder' }} />  <ListItemText primary="Vacate" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/AdvanceBookingIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <EventIcon style={{ color: '#352F44', fontWeight: 'bolder' }} />  <ListItemText primary="Advance Booking" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ExpenseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ArrowBackIcon style={{ color: '#ED7D31', fontWeight: 'bolder' }} />  <ListItemText primary="Expense" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/IncomeIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ArrowForwardIcon style={{ color: '#D2DE32', fontWeight: 'bolder' }} />  <ListItemText primary="Income" style={{ marginLeft: '3px' }} />
                </ListItem>

              </List>
            </Collapse>

            {/* {roleName != "Accounts" && ( */}
            <ListItem button onClick={handleReportClick}>
              <ListItemText primary="REPORT" />
              {reportOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            {/* )} */}

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>


                <ListItem button component={NavLink} to="/Ledger" activeClassName="selected" onClick={handleDrawerClose}>
                  <LibraryBooksIcon style={{ color: '#9E4784' }} /><ListItemText primary="Ledger" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/LedgerIncExp" activeClassName="selected" onClick={handleDrawerClose}>
                  <ArticleIcon style={{ color: '#B3005E' }} /><ListItemText primary="Ledger INC/EXP" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CashBook" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountBalanceWalletIcon style={{ color: '#FF8787' }} /><ListItemText primary="Cash Book" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Dues" activeClassName="selected" onClick={handleDrawerClose}>
                  <WarningIcon style={{ color: '#B46060' }} /><ListItemText primary="Dues" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Received" activeClassName="selected" onClick={handleDrawerClose}>
                  <CheckCircleIcon style={{ color: '#E57C23' }} /><ListItemText primary="Received" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/RentDetails" activeClassName="selected" onClick={handleDrawerClose}>
                  <InfoIcon style={{ color: '#025464' }} /><ListItemText primary="RentDetails" style={{ marginLeft: '3px' }} />
                </ListItem>

              </List>
            </Collapse>



            <ListItem button onClick={handleUserClick}>
              <ListItemText primary="USER" />
              {userOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                {/* {roleName == "SuperAdmin" && ( */}

                <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px' }} />
                </ListItem>
                {/* )} */}

                {/* {roleName == "SuperAdmin" && ( */}
                <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px' }} />
                </ListItem>
                {/* )} */}

                <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
                  <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
                </ListItem>
              </List>
            </Collapse>

          </List>
        </Drawer>
        {/* )} */}

        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />
            {/* Company */}
            <Route path="/CompanyIndex" component={CompanyIndex} />
            <Route path="/CompanyCreate" component={CompanyCreate} />
            <Route path="/CompanyEdit/:id" component={CompanyEdit} />
            {/* Room */}
            <Route path="/RoomIndex" component={RoomIndex} />
            <Route path="/RoomCreate" component={RoomCreate} />
            <Route path="/RoomsEdit/:id" component={RoomsEdit} />
            {/* Customer */}
            <Route path="/CustomerIndex" component={CustomerIndex} />
            <Route path="/CustomerCreate" component={CustomerCreate} />
            <Route path="/CustomerEdit/:id" component={CustomerEdit} />
            <Route path="/ConfirmCustomer/:id" component={ConfirmCustomer} />
            {/* Rent Collection */}
            <Route path="/RentedCustomerIndex" component={RentedCustomerIndex} />
            <Route path="/RentListIndex" component={RentListIndex} />
            <Route path="/BillPrint/:id" component={BillPrint} />
            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />
            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />
            {/* Bank */}
            <Route path="/BankIndex" component={BankIndex} />
            <Route path="/BankCreate" component={BankCreate} />
            <Route path="/BankEdit/:id" component={BankEdit} />
            {/* ExpenseHead */}
            <Route path="/ExpenseHeadIndex" component={ExpenseHeadIndex} />
            <Route path="/ExpenseHeadCreate" component={ExpenseHeadCreate} />
            <Route path="/ExpenseHeadEdit/:id" component={ExpenseHeadEdit} />
            {/* Receipt */}
            <Route path="/ReceiptIndex" component={ReceiptIndex} />
            <Route path="/ReceiptCreate" component={ReceiptCreate} />
            <Route path="/ReceiptEdit/:id" component={ReceiptEdit} />
            {/* Payment */}
            <Route path="/PaymentIndex" component={PaymentIndex} />
            <Route path="/PaymentCreate" component={PaymentCreate} />
            <Route path="/PaymentEdit/:id" component={PaymentEdit} />
            {/* Income */}
            <Route path="/IncomeIndex" component={IncomeIndex} />
            <Route path="/IncomeCreate" component={IncomeCreate} />
            <Route path="/IncomeEdit/:id" component={IncomeEdit} />
            {/* Expense */}
            <Route path="/ExpenseIndex" component={ExpenseIndex} />
            <Route path="/ExpenseCreate" component={ExpenseCreate} />
            <Route path="/ExpenseEdit/:id" component={ExpenseEdit} />
            {/* Report */}
            <Route path="/Ledger" component={Ledger} />
            <Route path="/LedgerIncExp" component={LedgerIncExp} />
            <Route path="/CashBook" component={CashBook} />
            <Route path="/Dues" component={Dues} />
            <Route path="/Received" component={Received} />
            <Route path="/RentDetails" component={RentDetails} />
            {/* Vacating */}
            <Route path="/customervacating" component={customervacating} />
            {/* AdvanceBooking */}
            <Route path="/AdvanceBookingIndex" component={AdvanceBookingIndex} />

          </Switch>
        </Container>


      </AuthProvider >
    </Router >
  );
};

export default App;

